// Plaqora product personalization: blocks add-to-cart when required fields
// (Nom / Numéro WhatsApp) are empty, and keeps any wa.me order links on the
// page in sync with the current Nom / Fonction / Numéro WhatsApp values.
(function () {
  function init(root) {
    var formId = root.getAttribute('data-form');
    var form = formId ? document.getElementById(formId) : root.closest('form');
    if (!form) return;

    var nameInput = root.querySelector('[data-pp-field="name"]');
    var fnInput = root.querySelector('[data-pp-field="function"]');
    var waInput = root.querySelector('[data-pp-field="whatsapp"]');
    var errorEl = root.querySelector('[data-pp-error]');

    function requiredFields() {
      return Array.prototype.filter.call(
        root.querySelectorAll('input[data-pp-required="true"]'),
        function (el) { return true; }
      );
    }

    function normalisePhone(value) {
      return (value || '').replace(/[().-]/g, ' ').replace(/\s+/g, ' ').trim();
    }

    function isValidMoroccanWhatsApp(value) {
      var phone = normalisePhone(value);
      return /^(?:0[67](?:[\s.-]?\d{2}){4}|\+212[\s.-]?[67](?:[\s.-]?\d{2}){4})$/.test(phone);
    }

    function invalidFields() {
      var fields = requiredFields();
      var invalid = fields.filter(function (el) { return !el.value || !el.value.trim(); });
      if (waInput && waInput.value && !isValidMoroccanWhatsApp(waInput.value)) invalid.push(waInput);
      return invalid.filter(function (el, index, list) { return list.indexOf(el) === index; });
    }

    function validate() {
      var invalid = invalidFields();
      var valid = invalid.length === 0;
      [nameInput, fnInput, waInput].forEach(function (input) {
        if (!input) return;
        input.setAttribute('aria-invalid', invalid.indexOf(input) !== -1 ? 'true' : 'false');
      });
      if (errorEl) {
        errorEl.textContent = waInput && waInput.value && !isValidMoroccanWhatsApp(waInput.value)
          ? 'Merci d’indiquer un numéro WhatsApp marocain valide — par exemple 06 XX XX XX XX ou +212 6 XX XX XX XX.'
          : 'Merci de compléter les informations obligatoires — nous en avons besoin pour vous envoyer la conception.';
        errorEl.hidden = valid;
      }
      return valid;
    }

    form.addEventListener('submit', function (evt) {
      var fields = requiredFields();
      fields.forEach(function (el) { el.setAttribute('data-pp-touched', 'true'); });
      var invalid = invalidFields();
      if (!validate()) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        if (invalid[0]) invalid[0].focus();
      }
    }, true);

    [nameInput, fnInput, waInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', function () {
        input.setAttribute('data-pp-touched', 'true');
        validate();
        syncWhatsappLinks();
      });
    });

    function syncWhatsappLinks() {
      var links = document.querySelectorAll('[data-wa-order-link]');
      if (!links.length) return;
      var name = nameInput ? nameInput.value.trim() : '';
      var fn = fnInput ? fnInput.value.trim() : '';
      var wa = waInput ? waInput.value.trim() : '';
      links.forEach(function (a) {
        var base = a.getAttribute('data-wa-base');
        if (!base) return;
        var lines = [
          'Bonjour Plaqora, je souhaite commander une plaque de bureau.',
          'Nom : ' + (name || '—'),
          'Fonction : ' + (fn || '—'),
          'WhatsApp : ' + (wa || '—')
        ];
        a.href = base + '?text=' + encodeURIComponent(lines.join('\n'));
      });
    }

    syncWhatsappLinks();
  }

  function boot() {
    document.querySelectorAll('[data-product-personalization]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
